import * as React from "react";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

type ShowNumberProps = {
  label: string;
  value: number;
  helperText?: string;
  error?: boolean;
  description?: string;
  decimalSeparator?: string;
  prefix?: string;
  suffix?: string;
  thousandsGroupStyle?: "none" | "thousand" | "lakh" | "wan";
  thousandSeparator?: string;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  customWidth?: number;
  hidden?: boolean;
};

export const ShowNumber: React.FC<ShowNumberProps> = ({
  label,
  value,
  helperText = "",
  error = false,
  description,
  decimalSeparator = ".",
  prefix,
  suffix,
  thousandsGroupStyle = "none",
  thousandSeparator,
  decimalScale = 0,
  fixedDecimalScale = false,
  customWidth = 500,
  hidden = false,
}) => {
  if (hidden) return null;
  return (
    <NumericFormat
      autoFocus={false}
      size={"small"}
      value={value}
      customInput={TextField}
      disabled
      allowNegative={true}
      allowedDecimalSeparators={[decimalSeparator]}
      decimalSeparator={decimalSeparator}
      prefix={prefix}
      suffix={suffix}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      thousandSeparator={thousandSeparator}
      thousandsGroupStyle={thousandsGroupStyle}
      error={error}
      helperText={helperText}
      sx={{ m: 1, mb: 1.5, width: customWidth }}
      label={<FieldLabelWithHelp label={label} description={description} />}
    />
  );
};
